import { Box } from '../../Box';
import { forwardRef } from 'react';
import { flagStyleBuilder, iconStartFlagStyleBuilder, swallowTailStyleBuilder } from './flagStyleBuilder';
import { styled } from '@mui/material/styles';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { idBuilder } from '../../internal/utils/idBuilder';

/**
 * Ways to show a status, classification, or count
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Flag = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    children,
    id,
    sx,
    variant,
    startIcon,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const flagStyle = mergeSxStyle(flagStyleBuilder(theme, variant), sx);
  const iconStartStyle = {
    ...iconStartFlagStyleBuilder(variant, theme)
  };
  const swallowTailStyle = {
    ...swallowTailStyleBuilder(variant, theme)
  };
  const StyledFlagContainer = styled('div')(_ref => {
    let {
      theme
    } = _ref;
    return {
      display: 'flex',
      gap: '4px',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0px 6px',
      height: '16px'
    };
  });
  return /*#__PURE__*/_jsxs(Box, {
    className: `interstate-flag ${className ?? ''}`,
    id: id,
    "data-testid": idBuilder(rest['data-testid'] ?? '', undefined),
    sx: flagStyle,
    children: [/*#__PURE__*/_jsx(Box, {
      id: idBuilder('flag-head', id),
      className: 'interstate-flag-head',
      "data-testid": idBuilder('flag-head', rest['data-testid']),
      children: /*#__PURE__*/_jsxs(StyledFlagContainer, {
        id: idBuilder('flag-head-content', id),
        className: 'interstate-flag-head-content',
        "data-testid": idBuilder('flag-head-content', rest['data-testid']),
        children: [startIcon && /*#__PURE__*/_jsx("span", {
          style: iconStartStyle,
          children: startIcon
        }), children]
      })
    }), /*#__PURE__*/_jsx(Box, {
      id: idBuilder('flag-tail', id),
      className: 'interstate-flag-tail',
      sx: swallowTailStyle,
      "data-testid": idBuilder('flag-tail', rest['data-testid'])
    })]
  });
});
Flag.displayName = 'Flag';